<template>
  <div class="w-full">
    <component :editObj="editObj" :is="activeNumberMod" :numberKeys="numberKeys" :numbers="numbers"/>
  </div>
</template>

<script>
  import firebase from "firebase";
  import {eventBus} from "../../eventbus";
  import {db} from '@/db'
  import NumberAdd from "./NumberAdd";
  import NumberContent from "./NumberContent";
  import NumberEdit from "./NumberEdit";

  export default {
    name: "NumberIndex",
    components: {
      NumberAdd,
      NumberContent,
      NumberEdit
    },
    data: () => ({
      numberKeys: [],
      numbers: [],
      editObj: {},
      activeNumberMod: 'NumberContent'
    }),
    firebase: {
      numbers: db.ref('numbers').orderByChild('state'),
    },
    watch: {
      numbers() {
        this.getKeys()
      }
    },
    methods: {
      getKeys() {
        let keys = []
        firebase.database().ref('numbers/').once('value', function (snapshot) {
          snapshot.forEach(function (childSnapshot) {
            let key = {key: childSnapshot.key}
            let value = childSnapshot.val()
            keys.push({...key, ...value})

          })
        })
        this.numberKeys = keys
      },
      listener() {
        eventBus.$on('AddNumber', () => this.activeNumberMod = 'NumberAdd')
        eventBus.$on('AllNumber', () => this.activeNumberMod = 'NumberContent')
        eventBus.$on('EditNumber', (x) => {
          this.editObj = x;
          this.activeNumberMod = 'NumberEdit'

        })
      }
    },
    created() {
      this.listener()
    }
  }
</script>

<style scoped>

</style>